import {LookupConfigSpec, LookupStepType} from 'lookup-config/LookupConfigModalConstants';

export default function isLookupConfigCustomMapping(
  lookupConfig: LookupConfigSpec,
  mappingSourceFieldId: string
): boolean {
  const lastStep = lookupConfig.lookupSteps[lookupConfig.lookupSteps.length - 1];
  return lastStep.type !== LookupStepType.SCHEMA_FIELD || lastStep.schemaField !== mappingSourceFieldId;
}
